module.exports = __webpack_public_path__ + "static/media/icon-close.23fe2027.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-close.svg
// module id = 666
// module chunks = 0